import React from "react";
import { SEO, PageLayout } from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class FaqPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout hero={false} subfooter={false} className={"faq-page"}>
          <Grid stackable={true} textAlign={"left"} centered={true}>
            <Grid.Column width={14}>
              <Grid stackable={true} textAlign={"left"} centered={true}>
                <Grid.Column width={10}>
                  <div className={"question-row"}>
                    <h5>How to find us?</h5>
                    <p>
                      We are at 207 W Broughton Lane. If you make it to the
                      front of the building at 207 W Broughton Street (Dottie’s
                      Restaurant) we are underneath your feet in the basement.
                      Don’t look down just walk around back.
                    </p>
                  </div>
                  <div className={"question-row"}>
                    <h5>Are minors permitted?</h5>
                    <p>Unfortunately, not per city regulations.</p>
                  </div>
                  <div className={"question-row"}>
                    <h5>Do you take reservations?</h5>
                    <p>
                      We are first come, first serve but please contact us if
                      you have a larger party and we will do our best to
                      accommodate your needs. A few days’ notice is helpful.
                    </p>
                  </div>
                  <div className={"question-row"}>
                    <h5>Do you host private parties and events?</h5>
                    <p>Yes, we do. Contact us for more information.</p>
                  </div>
                  <div className={"question-row"}>
                    <h5>What if I have suggestions, comments, or concerns?</h5>
                    <p>
                      We want to hear from you. Leave a number and you will be
                      contacted promptly.
                    </p>
                  </div>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(title: { eq: "Faq" }) {
      title
      components {
        fastId
        componentIdentifier
        order
        files {
          file
        }
      }
    }
  }
`;
